import { useCreativeBidStream } from 'components/common/Deal/CreativeBidStream/useCreativeBidStream';
import { BidsSubmissionSwitch } from './BidsSubmissionSwitch';

const ConnectedBidsSubmissionSwitch = (): React.ReactElement => {
  const { handleToggle, isToggleDisabled, isCreativeSubmissionInBidStreamEnabled } = useCreativeBidStream();

  return (
    <BidsSubmissionSwitch
      isChecked={isCreativeSubmissionInBidStreamEnabled}
      onChange={handleToggle}
      isDisabled={isToggleDisabled}
    />
  );
};

export default ConnectedBidsSubmissionSwitch;
